import type { ButtonProps } from '@mantine/core';
import type { MouseEventHandler, ReactNode } from 'react';
import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { warningNotificationIcon } from '@/theme/notificationIcons';
import { useOnlineStatus } from '@/utils/useOnlineStatus';

interface MutationButtonProps extends ButtonProps {
  isPending?: boolean;
  isPaused?: boolean;
  children?: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

/**
 * Dvije stvari: (1) proaktivno — čim navigator.onLine padne (isti event kao
 * NetworkStatusWatcher), gumb se onemogući ODMAH, prije nego korisnik uopće
 * klikne; (2) reaktivno — ako je mutacija svejedno okinuta i React Query je
 * pauzirao (networkMode: 'online', default — isPending ostaje true, zahtjev
 * nikad nije ni krenuo), pokrivamo i taj slučaj istim izgledom. Bez ovoga gol
 * Button s loading={isPending} bi beskonačno vrtio spinner bez objašnjenja.
 */
export const MutationButton = ({ isPending, isPaused, children, ...rest }: MutationButtonProps) => {
  const { t } = useTranslation();
  const isOnline = useOnlineStatus();

  if (isPaused || !isOnline) {
    return (
      <Button {...rest} disabled leftSection={warningNotificationIcon}>
        {t('common.waitingForNetwork')}
      </Button>
    );
  }

  return (
    <Button {...rest} loading={isPending}>
      {children}
    </Button>
  );
};
